import type React from 'react'
import type { IconProps } from './types'

/**
 * Linear Scale Icon - Material Symbols "linear_scale"
 * Used for eNPS module
 */
const LinearScaleIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M9 12C9 13.1 8.1 14 7 14C6.58 14 6.19 13.88 5.86 13.68L3.5 15.5L2.5 14.5L4.68 11.86C4.28 11.41 4 10.78 4 10C4 8.9 4.9 8 6 8C6.42 8 6.81 8.12 7.14 8.32L9.5 6.5L10.5 7.5L8.32 10.14C8.72 10.59 9 11.22 9 12ZM12 8C10.9 8 10 8.9 10 10C10 11.1 10.9 12 12 12C13.1 12 14 11.1 14 10C14 8.9 13.1 8 12 8ZM18 8C16.9 8 16 8.9 16 10C16 10.78 16.28 11.41 16.68 11.86L14.5 14.5L15.5 15.5L17.86 13.68C18.19 13.88 18.58 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10C19 8.9 18.1 8 18 8Z' />
	</svg>
)

export default LinearScaleIcon
